import { TranslationDTO } from "../TranslationDTO";
// 
import type { OptionCollectionItemDTO } from "@hitit/api";
import type OptionCategory from "./OptionCategory";
export type ConvinienceConstructorArg = {
    id: string,
    name: string,
    price: number,
    stock?: number,
    displaySort: number
    priceCurrency: string
}


export default class OptionItem {
    collection: OptionCategory
    translationDTOs: TranslationDTO[]
    enabled: boolean;
    displaySort: number;
    taxPercent: number;
    taxable: boolean;
    priceCurrency: string;
    price: number;
    inventory: number;
    deliverable: boolean;
    takeoutable: boolean;
    sellableInStore: boolean;
    sellableOnline: boolean;
    preOrderable: boolean;
    validFromDate: string;
    validUntil?: string
    id?: string;
    uid?: string;

    static convienceArg(displaySort: number, id: string, priceCurrency = "KRW"): ConvinienceConstructorArg {
        return {
            id,
            name: "",
            displaySort,
            price: 0,
            stock: 0,
            priceCurrency: priceCurrency
        }
    }

    static convinienceConstructor(arg: ConvinienceConstructorArg, lang = "ko", collection: OptionCategory) {
        const { name, displaySort, price, stock, id, priceCurrency } = arg

        const translation = new TranslationDTO(name, lang)
        const optionItem: OptionCollectionItemDTO = {
            translationDTOs: [translation],
            id: id,
            uid: undefined,
            enabled: true,
            displaySort: displaySort,
            taxPercent: 0,
            taxable: true,
            priceCurrency: priceCurrency,
            price: price,
            inventory: stock || 0,
            takeoutable: false,
            deliverable: false,
            sellableInStore: false,
            sellableOnline: false,
            preOrderable: false,
            validFromDate: (new Date()).toISOString(),
            validUntil: undefined,
        }

        return new OptionItem(optionItem, collection)
    }



    constructor(optionItem: OptionCollectionItemDTO, collection: OptionCategory) {
        this.translationDTOs = optionItem.translationDTOs.map(v => TranslationDTO.convinienceConstructor(v))
        this.id = optionItem.id
        this.uid = optionItem.uid
        this.enabled = optionItem.enabled
        this.displaySort = optionItem.displaySort
        this.taxPercent = optionItem.taxPercent
        this.taxable = optionItem.taxable as unknown as boolean
        this.priceCurrency = optionItem.priceCurrency
        this.price = optionItem.price
        this.inventory = optionItem.inventory
        this.takeoutable = optionItem.takeoutable
        this.deliverable = optionItem.deliverable
        this.sellableInStore = optionItem.sellableInStore
        this.sellableOnline = optionItem.sellableOnline
        this.preOrderable = optionItem.preOrderable
        this.validFromDate = optionItem.validFromDate
        this.validUntil = optionItem.validUntil
        this.collection = collection
    }

    public setTranslation(translation: TranslationDTO) {
        this.translationDTOs = [
            ...this.translationDTOs.filter(v => v.lang !== translation.lang),
            translation
        ]
    }

    public getTranslation() {
        return this.translationDTOs
    }

    public getPrice() {
        return this.price
    }

    public getStockAvailable() {
        return true
    }

    public getStock() {
        return this.inventory
    }

    public getClone() {
        const arg: OptionCollectionItemDTO = {
            translationDTOs: this.translationDTOs.map(v => TranslationDTO.convinienceConstructor(v)),
            enabled: this.enabled,
            displaySort: this.displaySort,
            taxPercent: this.taxPercent,
            taxable: this.taxable,
            priceCurrency: this.priceCurrency,
            price: this.price,
            inventory: this.inventory,
            deliverable: this.deliverable,
            takeoutable: this.takeoutable,
            sellableInStore: this.sellableInStore,
            sellableOnline: this.sellableOnline,
            preOrderable: this.preOrderable,
            validFromDate: this.validFromDate,
            validUntil: this.validUntil,
            id: this.id,
            uid: this.uid
        }

        return new OptionItem(arg, this.collection);
    }

    public getOptionCollectionItemDTO() {
        const reg = /^\|NEW_ITEM\|/;
        const dto: OptionCollectionItemDTO = {
            translationDTOs: this.translationDTOs.map(v => TranslationDTO.convinienceConstructor(v)),
            enabled: this.enabled,
            displaySort: this.displaySort,
            taxPercent: this.taxPercent,
            taxable: this.taxable,
            priceCurrency: this.priceCurrency,
            price: this.price,
            inventory: this.inventory,
            deliverable: this.deliverable,
            takeoutable: this.takeoutable,
            sellableInStore: this.sellableInStore,
            sellableOnline: this.sellableOnline,
            preOrderable: this.preOrderable,
            validFromDate: this.validFromDate,
            validUntil: this.validUntil ? undefined : this.validUntil,
            id: reg.test(this.id!) ? undefined : this.id,
            uid: reg.test(this.id!) ? undefined : this.uid
        }

        return dto
    }

}